module.exports = __webpack_public_path__ + "operace-nosu_5_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-nosu_5_before.jpg
// module id = 1138
// module chunks = 0